import { render, staticRenderFns } from "./CompanyTreeView.vue?vue&type=template&id=6330afe2&scoped=true"
import script from "./CompanyTreeView.vue?vue&type=script&lang=js"
export * from "./CompanyTreeView.vue?vue&type=script&lang=js"
import style0 from "./CompanyTreeView.vue?vue&type=style&index=0&id=6330afe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6330afe2",
  null
  
)

export default component.exports